<template>
  <v-container id="paymentreceived-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <!-- <base-material-card
          icon="mdi-card-text-outline"
          :title="
            collect_id
              ? $i18n.t('Edit Payment Recceived')
              : $i18n.t('Add Payment Recceived')
          "
          class="px-3 py-1 small-icon"
        > -->
        <v-card>
          <v-btn
            style="position: absolute; right: 0px; top: -10px"
            x-small
            color="blue"
            v-if="collect_id && !singlePage"
            href="/paymentreceived/create"
            >+ Add New</v-btn
          >
          <v-form id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" sm="5" md="4" lg="3" v-if="!singlePage">
                  <z-client-select
                    v-model="collectible.client_id"
                    :disabled="isEdit || singlePage"
                    autocomplete="off"
                    @change="fetchOpeningBalDetails()"
                  />
                </v-col>

                <v-col cols="12" sm="5" md="4" lg="3" v-if="!singlePage">
                  <z-entity-select
                    :corp="collectible.client_id"
                    v-model="collectible.clientEntity_id"
                    :disabled="isEdit"
                    autocomplete="off"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="7" lg="2" v-if="!singlePage">
                  <v-text-field
                    v-model="collectible.bankName"
                    :label="$i18n.t('Bank Name')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <z-date-picker
                    :label="$i18n.t('Payment Date')"
                    v-model="collectible.date"
                    @change="fetchOpeningBalDetails()"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <!-- <z-payment-mode-select
                    :label="$i18n.t('Payment Mode')"
                    v-model="collectible.mode"
                  /> -->
                  <z-name-master-select
                    v-model="collectible.mode"
                    :type="7"
                    @click.native.stop
                    :label="$i18n.t('Payment Mode')"
                    :hideAddNew="true"
                  />
                </v-col>
                <!-- </v-row> -->

                <!-- <v-row> -->
                <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                  <z-currency-select
                    :label="$i18n.t('Currency')"
                    v-model="collectible.currency"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    type="number"
                    v-model="collectible.amountReceived"
                    @change="recalculateTotal()"
                    :label="$i18n.t('Amount Received')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                  <v-text-field
                    type="number"
                    v-model="collectible.tds"
                    @change="recalculateTotal()"
                    :label="$i18n.t('TDS Deducted ')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                  <v-text-field
                    type="number"
                    v-model="collectible.totalAmount"
                    :label="$i18n.t('Total Amount')"
                    :disabled="true"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    type="number"
                    v-model="prevCollect.advance"
                    :label="$i18n.t('Advance Available')"
                    :disabled="true"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field
                    type="number"
                    v-model="collectible.advanceAmount"
                    :label="$i18n.t('Excess Amount')"
                    :disabled="true"
                  />
                </v-col>
                <!-- </v-row> -->

                <!-- <v-row> -->
                <v-col cols="12" sm="6" md="3" lg="2" v-if="!singlePage">
                  <v-text-field
                    type="number"
                    v-model="openingbalance.settled"
                    :label="$i18n.t('Settle')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3" v-if="!singlePage">
                  <label>Opening : {{ openingbalance.opening }}</label>
                  <br />
                  <label>Settled : {{ openingbalance.currentSettled }}</label>
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="3">
                  <v-text-field
                    v-model="collectible.transactionID"
                    :label="$i18n.t('Transaction ID')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="3" lg="4">
                  <z-fund-account-select multiple="false" v-model="collectible.fundAC_id" :label="$i18n.t('Fund Account Select')" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="4">
                  <v-text-field
                    v-model="collectible.detail"
                    :label="$i18n.t('Details')"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    color="info"
                    class="mr-0"
                    @click="save()"
                    :loading="loading"
                  >
                    <h3>{{ $i18n.t("Save") }}</h3>
                  </v-btn>
                </v-col>
                
              </v-row>
            </v-col>
          </v-form>
        </v-card>
         

              <v-row v-if="!makeHideInvoices">
                <v-col cols="12">
                  <!-- <v-card> -->
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                  >
                    <h3>{{ $i18n.t("Invoices") }}</h3>
                  </v-btn>
                  <z-invoice-select
                    v-if="
                      collectible.client_id &&
                      (!collectible.tripList || collectible.tripList.length < 1)
                    "
                    style="float: right"
                    :client_id="collectible.client_id"
                    :statuses="'1,5'"
                    :invoices="selectedInvoice_ids"
                    @selectedInvoices="selectedInvoices"
                    btn
                  >
                    <v-btn color="cyan" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Invoices(s)") }}
                    </v-btn>
                  </z-invoice-select>
                  <v-simple-table dense class="table-border">
                    <thead>
                      <tr>
                        <th class="primary--text" style="width: 10%">
                          {{ $i18n.t("Invoice No") }}
                        </th>
                        <th class="primary--text" style="width: 10%">
                          {{ $i18n.t("Date") }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Amount") }}
                        </th>
                        <th class="primary--text text-right">
                          {{
                            $i18n.t("Current") + " " + $i18n.t("Outstanding")
                          }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Collect Amount") }}
                        </th>
                        <th class="primary--text" style="width: 7%">
                          {{ $i18n.t("TDS") + "%" }}
                        </th>
                        <th class="primary--text">
                          {{ $i18n.t("TDS on total amount") }}
                        </th>
                        <th class="primary--text text-right" style="width: 10%">
                          {{ $i18n.t("TDS") }}
                        </th>
                        <th class="primary--text text-right" style="width: 10%">
                          {{ $i18n.t("Write Off") }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Outstanding after Collection") }}
                        </th>
                        <th class="text-right primary--text" style="width: 10%">
                          {{ $i18n.t("Action") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        collectible.invoiceList &&
                        collectible.invoiceList.length > 0
                      "
                    >
                      <tr
                        v-for="(invoice, index) in collectible.invoiceList"
                        :key="'invoice' + index"
                      >
                        <td>
                          <b>{{ invoice.invoiceNo }}</b>
                        </td>
                        <td>
                          {{ formatDate(invoice.invoiceDate) }}
                        </td>
                        <td class="text-right">{{ invoice.fare }}</td>
                        <td class="text-right">
                          {{ invoice.toBeCollected }}
                        </td>
                        <td class="text-right">
                          <v-text-field
                            @change="calculateTDSTax(invoice)"
                            type="number"
                            class="form-control"
                            v-model="invoice.collectAmount"
                            dense
                          />
                        </td>
                        <td>
                          <v-text-field
                            type="number"
                            @change="calculateTDSTax(invoice)"
                            class="form-control"
                            v-model="invoice.tdsPercent"
                            dense
                          />
                        </td>
                        <td>
                          <v-checkbox
                            dense
                            @change="calculateTDSTax(invoice)"
                            class="form-control"
                            v-model="invoice.tdsOnTotal"
                          />
                        </td>
                        <td class="text-right">
                          <v-text-field
                            type="number"
                            class="form-control"
                            v-model="invoice.tds"
                            dense
                          />
                        </td>
                        <td class="text-right">
                          <v-text-field
                            type="number"
                            class="form-control"
                            v-model="invoice.writeOff"
                            dense
                          />
                        </td>
                        <td class="text-right" ng-cloak>
                          {{ getPendingAmount(invoice) }}
                        </td>

                        <td>
                          <v-btn
                            v-if="
                              !collectible.tripList ||
                              collectible.tripList.length < 1
                            "
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            dense
                            @click="moveToDeleted(invoice, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                    <tfoot
                      v-if="
                        collectible.invoiceList &&
                        collectible.invoiceList.length > 0
                      "
                    >
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="text-align: right">
                          {{ getTotalCurrentOutstanding() }}
                        </td>
                        <td style="text-align: right">
                          {{ getTotalCollectAmount() }}
                        </td>
                        <td></td>
                        <td></td>
                        <td style="text-align: right">
                          {{ getTotalTDSAmount() }}
                        </td>
                        <td style="text-align: right">
                          {{ getTotalWriteOffAmount() }}
                        </td>
                        <td style="text-align: right">
                          {{ getTotalPendingAmount() }}
                        </td>
                        <td style="text-align: right">
                          {{ $i18n.t("Total") + ": " + settledTotal() }}
                        </td>
                      </tr>

                    </tfoot>
                  </v-simple-table>
                </v-col>
              </v-row>

              <v-row v-if="!hideTrips">
                <v-col cols="12">
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                  >
                    <h3>{{ $i18n.t("Trips") }}</h3>
                  </v-btn>

                  <!-- <z-trip-select
                    v-if="collectible.client_id"
                    style="float: right"
                    :client_id="collectible.client_id"
                    :statuses="'1,2,3,4,5,6,7'"
                    :trips="tripList"
                    @selectedTrip="selectedTrip"
                    btn
                  >
                    <v-btn color="cyan" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Trips(s)") }}
                    </v-btn>
                  </z-trip-select> -->
                  <v-simple-table dense class="table-border">
                    <thead>
                      <tr>
                        <th class="primary--text" style="width: 10%">
                          {{ $i18n.t("Trip No") }}
                        </th>
                        <th class="primary--text" style="width: 10%">
                          {{ $i18n.t("Date") }} / {{ $i18n.t("Time") }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Amount") }}
                        </th>
                        <th class="primary--text text-right">
                          {{
                            $i18n.t("Current") + " " + $i18n.t("Outstanding")
                          }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Collect Amount") }}
                        </th>
                        <th class="primary--text text-right">
                          {{ $i18n.t("Outstanding after Collection") }}
                        </th>
                        <th class="text-right primary--text" style="width: 10%">
                          <!-- {{ $i18n.t("Action") }} -->
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        collectible.tripList && collectible.tripList.length > 0
                      "
                    >
                      <tr
                        v-for="(trip, index) in collectible.tripList"
                        :key="'trip' + index"
                      >
                        <td>
                          <b>{{ trip.tripNo }}</b>
                        </td>
                        <td>
                          {{ trip.startTime | moment("DD-MM-YYYY") }}
                          <!-- {{ trip.startTime | moment("HH:mm DD MMM YYYY") }} -->
                        </td>
                        <td class="text-right">{{ trip.fare }}</td>
                        <td class="text-right">
                          {{ trip.toBeCollected }}
                        </td>
                        <td class="text-right">
                          <span v-if="singlePage">{{
                            trip.collectAmount
                          }}</span>
                          <v-text-field
                            v-if="!singlePage"
                            @change="setRemainingAmount()"
                            type="number"
                            class="form-control"
                            v-model="trip.collectAmount"
                            dense
                          />
                        </td>
                        <td class="text-right" ng-cloak>
                          {{ getPendingAmount(trip) }}
                        </td>

                        <td>
                          <!-- <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            dense
                            @click="moveToDeleted(trip, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn> -->
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                    <tfoot
                      v-if="
                        collectible.tripList && collectible.tripList.length > 0 && !singlePage
                      "
                    >
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="text-align: right">
                          {{ getTotalCurrentOutstandingTrip() }}
                        </td>
                        <td style="text-align: right">
                          {{ getTotalCollectAmountTrip() }}
                        </td>
                        <td style="text-align: right">
                          {{ getTotalPendingAmountTrip() }}
                        </td>
                        <td style="text-align: right">
                          {{ $i18n.t("Total") + ": " + settledTotalTrip() }}
                        </td>
                      </tr>
                    </tfoot>
                  </v-simple-table>
                  <!-- </v-card> -->
                </v-col>
              </v-row>

              
            </v-col>
        <!-- </base-material-card> -->
      
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";

@Component({
  name: "PaymentReceivedEdit",
  components: {},
  props: {
    singlePage: {
      default: null,
    },
    collectEdit_id: {
      default: null,
    },
    client_id: {
      default: null,
    },
    clientEntity_id: {
      default: null,
    },
    date: {
      default: null,
    },
    trip_id: {
      default: null,
    },
    invoice_id: {
      default: null,
    },
    trip: {
      default: null,
    },
    invoice: {
      default: null,
    },
    pendingAmount: {
      default: null,
    },
    paidAmount: {
      default: null,
    },
    itemTotalAmount: {
      default: null,
    },
    hideTrips: {
      default: null,
    },
    hideInvoices: {
      default: null,
    },
  },
})
export default class PaymentReceivedEdit extends Vue {
  isValid = true;
  isEdit = false;
  collectible = {
    fundAC_id:null,
    client_id: null,
    clientEntity_id: null,
    date: null,
    transactionID: null,
    currency: 'INR',
    amountReceived: null,
    totalAmount: null,
    tds: null,
    bankName: null,
    tax: null,
    detail: null,
    mode: null,
    invoiceList: [],
    tripList: [],
  };
  collect_id = null;
  fields = [];
  openingbalance = {};
  webcontent = {};
  tripList = "";
  selectedInvoice_ids = "";
  prevCollect = {};
  makeHideInvoices = false;

  get loading() {
    return common.loading;
  }

  @Watch("hideInvoices")
  onHideInvoicesChange(val) {
    this.makeHideInvoices = val;
  }

  async fetchPrevAdvanceCollect() {
    try {
      if (this.collectible.client_id) {
        this.prevCollect = {};
        let url =
          "/api/collectible/client/" +
          this.collectible.client_id +
          "/prev/payment?";
        if (this.collectible._id) {
          url = url + "&payment_id=" + this.collectible._id;
        }
        if (this.collectible.clientEntity_id) {
          url = url + "&clientEntity_id=" + this.collectible.clientEntity_id;
        }
        const _prevCollect = await doGet(url);
        this.prevCollect = _prevCollect;
      }
    } catch (e) {
      console.log(e);
    }
  }

  moveToDeleted(obj, index) {
    if (
      this.collectible.deleted == null ||
      this.collectible.deleted == undefined
    ) {
      this.collectible.deleted = [];
    }
    let found = false;
    for (let i = 0; i < this.collectible.deleted.length; i++) {
      if (
        this.isSet(this.collectible.deleted[i].invoice_id) &&
        this.collectible.deleted[i].invoice_id == obj.invoice_id
      ) {
        this.remove(this.collectible.invoiceList, index);
        found = true;
      }
    }
    if (!found) {
      this.collectible.deleted.push(obj);
      this.remove(this.collectible.invoiceList, index);
    }
  }

  calculateTDSTax(_invoice) {
    const tds = _invoice.tdsPercent;
    let amount = _invoice.collectAmount;
    if (_invoice && _invoice.tdsOnTotal) {
      amount = _invoice.fare;
    }
    _invoice.tds = this.roundOffToTwoDecimal((amount * tds) / 100);
    this.setRemainingAmount();
  }

  roundOffToTwoDecimal(num) {
    return Math.round(num * 100) / 100;
  }

  getPendingAmount(_invoice) {
    let amount = 0;
    if (_invoice.toBeCollected) {
      amount = parseFloat(_invoice.toBeCollected);
      if (_invoice.collectAmount) {
        amount = this.roundOffToTwoDecimal(
          amount - parseFloat(_invoice.collectAmount)
        );
      }
      if (_invoice.tds) {
        amount = this.roundOffToTwoDecimal(amount - parseFloat(_invoice.tds));
      }
      // if (_invoice.tax) {
      //    amount = this.roundOffToTwoDecimal(amount - parseFloat(_invoice.tax));
      // }
      if (_invoice.writeOff) {
        amount = this.roundOffToTwoDecimal(
          amount - parseFloat(_invoice.writeOff)
        );
      }
    }
    // if (amount < 0) {
    //    return 0;
    // }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalCollectAmount() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      this.collectible.invoiceList.forEach(function (inv) {
        if (inv.collectAmount) {
          amount = amount + parseFloat(inv.collectAmount);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalCurrentOutstanding() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      this.collectible.invoiceList.forEach(function (inv) {
        if (inv.toBeCollected) {
          amount = amount + parseFloat(inv.toBeCollected);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalCurrentOutstandingTrip() {
    let amount = 0;
    if (this.collectible && this.collectible.tripList) {
      this.collectible.tripList.forEach(function (trp) {
        if (trp.toBeCollected) {
          amount = amount + parseFloat(trp.toBeCollected);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalCollectAmountTrip() {
    let amount = 0;
    if (this.collectible && this.collectible.tripList) {
      this.collectible.tripList.forEach(function (trp) {
        if (trp.collectAmount) {
          amount = amount + parseFloat(trp.collectAmount);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalPendingAmountTrip() {
    let amount = 0;
    if (this.collectible && this.collectible.tripList) {
      for (let i = 0; i < this.collectible.tripList.length; i++) {
        amount =
          amount + this.getPendingAmountTrip(this.collectible.tripList[i]);
      }
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getPendingAmountTrip(_trip) {
    let amount = 0;
    if (_trip.toBeCollected) {
      amount = parseFloat(_trip.toBeCollected);
      if (_trip.collectAmount) {
        amount = this.roundOffToTwoDecimal(
          amount - parseFloat(_trip.collectAmount)
        );
      }
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalTDSAmount() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      this.collectible.invoiceList.forEach(function (inv) {
        if (inv.tds) {
          amount = amount + parseFloat(inv.tds);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalTaxAmount() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      this.collectible.invoiceList.forEach(function (inv) {
        if (inv.tax) {
          amount = amount + parseFloat(inv.tax);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalWriteOffAmount() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      this.collectible.invoiceList.forEach(function (inv) {
        if (inv.writeOff) {
          amount = amount + parseFloat(inv.writeOff);
        }
      });
    }
    return this.roundOffToTwoDecimal(amount);
  }

  getTotalPendingAmount() {
    let amount = 0;
    if (this.collectible && this.collectible.invoiceList) {
      for (let i = 0; i < this.collectible.invoiceList.length; i++) {
        amount =
          amount + this.getPendingAmount(this.collectible.invoiceList[i]);
      }
    }
    return this.roundOffToTwoDecimal(amount);
  }

  validatePayment() {
    if (this.isSet(this.collectible.invoiceList)) {
      // const total = 0;
      const totalSettled = this.settledTotal();
      const totalReceived = this.getTotal();

      if (
        this.roundOffToTwoDecimal(totalReceived) <
        this.roundOffToTwoDecimal(totalSettled)
      ) {
        common.setError(
          "Total amount filled <strong> (" +
            totalSettled +
            ") </strong> is greater than received amount <strong> (" +
            totalReceived +
            ") </strong>"
        );
        return false;
      }

      // const paymentAmount = this.roundOffToTwoDecimal(parseFloat(this.collectible.totalAmount));
      // total = total + this.getTotalCollectAmount() + this.getTotalTaxAmount() + this.getTotalTDSAmount() + this.getTotalWriteOffAmount();
      // total = total + this.getTotalCollectAmount() + this.getTotalTDSAmount();
      // if (total < paymentAmount) {
      //   common.setError(
      //     "Total amount filled (" +
      //       total +
      //       ") is less than received amount (" +
      //       paymentAmount +
      //       ") "
      //   );
      //   return false;
      // }
      // if (total > paymentAmount) {
      //   common.setError(
      //     "Total amount filled (" +
      //       total +
      //       ") is greater than received amount (" +
      //       paymentAmount +
      //       ") "
      //   );
      //   return false;
      // }
    }
    return true;
  }

  validateSave() {
    if (!this.isSet(this.collectible.date)) {
      common.setError("Please select payment date");
      return false;
    }
    if (!this.isSet(this.collectible.currency)) {
      common.setError("Please select currency");
      return false;
    }
    if (!this.isSet(this.collectible.amountReceived)) {
      common.setError("Please enter payment amount");
      return false;
    }
    if (!this.isSet(this.collectible.transactionID)) {
      common.setError("Please enter transaction ID");
      return false;
    }
    if (!this.isSet(this.collectible.mode)) {
      common.setError("Please select payment mode");
      return false;
    }
    if (!this.collectible.invoiceList) {
      if (
        !this.openingbalance ||
        !this.openingbalance.settled ||
        this.openingbalance.settled < 0
      ) {
        common.setError(
          "Please select either invoice or provide settled amount"
        );
        return false;
      }
    }

    if (this.collectible.invoiceList) {
      for (let i = 0; i < this.collectible.invoiceList.length; i++) {
        if (!this.isSet(this.collectible.invoiceList[i].collectAmount)) {
          common.setError(
            "Please enter collect amount in invoice " +
              this.collectible.invoiceList[i].invoiceNo
          );
          return false;
        }
        if (this.getPendingAmount(this.collectible.invoiceList[i]) < 0) {
          common.setError(
            "Outstanding after collection can not be less then 0 in invoice " +
              this.collectible.invoiceList[i].invoiceNo
          );
          return false;
        }
      }
    }
    return true;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      if (!this.validatePayment()) return false;

      this.collectible.settled = this.openingbalance.settled;
      //this.collectible.fundAC_id = "63f34e643b0806799d667236";
      //this.collectible.fundAC_id = null;
      common.setLoading(true);
      let url = "/api/collectible/edit";
      if (!this.collect_id) url = "/api/collectible/save";
      const response = await doPost(url, this.collectible);
      common.setLoading(false);
      common.showMessage("Saved Successfully");

      if (this.singlePage) {
        this.$emit("closeDialog", true);
      } else {
        if (!this.collect_id) {
          this.$router.push("/paymentreceived/" + response._id);
        }
        this.collect_id = response._id;
        this.get();
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  prepareCollectible(collectible) {
    if (!collectible) collectible = {};
    if (!collectible.client_id) collectible.client_id = null;
    if (!collectible.clientEntity_id) collectible.clientEntity_id = null;
    if (!collectible.date) collectible.date = null;
    if (!collectible.transactionID) collectible.transactionID = null;
    if (!collectible.currency) collectible.currency = "INR";
    if (!collectible.amountReceived) collectible.amountReceived = null;
    if (!collectible.advanceAmount) collectible.advanceAmount = null;
    if (!collectible.totalAmount) collectible.totalAmount = null;
    if (!collectible.tds) collectible.tds = null;
    if (!collectible.bankName) collectible.bankName = null;
    if (!collectible.tax) collectible.tax = null;
    if (!collectible.detail) collectible.detail = null;
    if (!collectible.mode) collectible.mode = null;
    if (!collectible.invoiceList) collectible.invoiceList = [];
    if (!collectible.tripList) collectible.tripList = [];
  }

  async get() {
    try {
      const response = await doGet(
        "/api/collectible/" + this.collect_id + "/detail"
      );
      if (!response.invoiceList) response.invoiceList = [];
      this.isEdit = true;
      this.prepareCollectible(response);
      if (
        (!response.invoiceList || response.invoiceList.length < 1) &&
        response.tripList &&
        response.tripList.length > 0
      )
        this.makeHideInvoices = true;
      if (
        (!response.tripList || response.tripList.length < 1) &&
        response.invoiceList &&
        response.invoiceList.length > 0
      )
        this.hideTrips = true;
      this.collectible = response;
      this.collect_id = this.collectible._id;
      this.populateInvoice_ids();
      this.fetchOpeningBalDetails();
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    await auth.doPostLogin();
    this.webcontent = auth.authContent;

    if (this.singlePage) {
      if (this.collectEdit_id) {
        this.$emit("setLoading", true);
        this.collect_id = this.collectEdit_id;
        await this.get();
        this.$emit("setLoading", false);
      } else {
        this.$emit("setLoading", true);
        const collect = {};
        collect.client_id = this.client_id;
        collect.clientEntity_id = this.clientEntity_id;
        collect.currency = "INR";
        collect.date = this.date;
        if (this.trip_id) {
          collect.against = 2;
          collect.tripList = [];
          const trip = {};
          trip.trip_id = this.trip_id;
          trip.tripNo = this.trip.tripNo;
          trip.startTime = this.trip.startTime;
          trip.fare = this.itemTotalAmount;
          trip.paid = this.paidAmount;
          trip.toBeCollected = this.pendingAmount;
          trip.collectAmount = this.pendingAmount;
          // collect.amountReceived = this.pendingAmount;
          collect.tripList.push(trip);
        }
        this.prepareCollectible(collect);
        this.collectible = collect;
        await this.recalculateTotal();
        this.$emit("setLoading", false);
      }
    } else if (this.$route.params.id) {
      this.collect_id = this.$route.params.id;
      await this.get();
    }
  }

  populateTrip_ids() {
    this.tripList = "";
    if (this.collectible.tripList) {
      for (let i = 0; i < this.collectible.tripList.length; i++) {
        if (this.collectible.tripList[i].trip_id) {
          this.tripList =
            this.tripList + this.collectible.tripList[i].trip_id + ",";
        }
      }
    }
  }

  selectedTrip(_trips) {
    if (_trips) {
      const client_id = this.collectible.client_id;
      const myCorp_id = this.webcontent.corp_id;
      for (let index = 0; index < _trips.length; index++) {
        const trip = _trips[index];
        const singleItem = {};
        singleItem.trip_id = trip._id;
        singleItem.tripNo = trip.tripNo;
        singleItem.startTime = trip.startTime;

        let fare = null;
        // if (trip.billings) {
        //   for (let j = 0; j < trip.billings.length; j++) {
        //     const billing = trip.billings[j];
        //     if (
        //       billing &&
        //       billing.client_id == client_id &&
        //       billing.vendor_id == myCorp_id
        //     ) {
        //       fare = billing.fare;
        //     }
        //   }
        // }
        if (trip.clientCargos) {
          for (let k = 0; k < trip.clientCargos.length; k++) {
            const clientCargo = trip.clientCargos[k];
            if (clientCargo && clientCargo.client_id && clientCargo.billing && clientCargo.client_id == client_id && trip.vendor_id == myCorp_id) {
              fare = clientCargo.billing.fare;
            }
          }
        }

        if (!fare) {
          common.setError("Fare not present in trip");
          return false;
        }
        if (!this.collectible.currency) {
          this.collectible.currency = "INR";
        }
        singleItem.collectAmount = null;
        singleItem.toBeCollected = null;
        this.collectible.tripList.push(singleItem);
      }
      this.populateTrip_ids();
    }
  }

  populateInvoice_ids() {
    this.selectedInvoice_ids = "";
    if (this.collectible.invoiceList) {
      for (let i = 0; i < this.collectible.invoiceList.length; i++) {
        if (this.collectible.invoiceList[i].invoice_id) {
          this.selectedInvoice_ids =
            this.selectedInvoice_ids +
            this.collectible.invoiceList[i].invoice_id +
            ",";
        }
      }
    }
  }

  selectedInvoices(_invoices) {
    if (_invoices) {
      const client_id = this.collectible.client_id;
      const myCorp_id = this.webcontent.corp_id;
      for (let index = 0; index < _invoices.length; index++) {
        const invoice = _invoices[index];
        if (
          invoice &&
          invoice.client_id == client_id &&
          invoice.vendor_id == myCorp_id
        ) {
          if (!this.collectible.currency) {
            this.collectible.currency = invoice.fare.currency;
          } else if (this.collectible.currency != invoice.fare.currency) {
            common.setError(
              "Currency mismatch in booking " +
                invoice.invoiceNo +
                ". " +
                invoice.fare.currency +
                "!"
            );
            return false;
          }

          if (!invoice.fare) {
            common.setError("Supplier fare not present in trip");
            return false;
          }

          const singleItem = {};
          singleItem.fare = invoice.fare.total;
          singleItem.invoice_id = invoice._id;
          singleItem.invoiceNo = invoice.invoiceNo;
          singleItem.invoiceDate = invoice.invoiceDate;
          singleItem.collectAmount = null;
          singleItem.tds = null;
          singleItem.tdsPercent = null;
          singleItem.toBeCollected = invoice.fare.pending;
          singleItem.tdsOnTotal = null;
          singleItem.writeOff = null;

          this.collectible.invoiceList.push(singleItem);
        }
      }
    }
  }

  @Watch("collectible.client_id")
  onClientChange() {
    this.fetchOpeningBalDetails();
    this.fetchPrevAdvanceCollect();
  }

  @Watch("collectible.clientEntity_id")
  onClientEntityChange() {
    this.fetchOpeningBalDetails();
    this.fetchPrevAdvanceCollect();
  }

  @Watch("collectible.date")
  onDateChange() {
    this.fetchOpeningBalDetails();
  }

  async fetchOpeningBalDetails() {
    const client_id = this.collectible.client_id;
    const clientEntity_id = this.collectible.clientEntity_id;
    const p_id = this.collect_id;
    const date = this.collectible.date;
    let year = null;
    if (date) {
      year = Math.round(date / 10000);
      const month = Math.round(Math.round(date / 100) % 100);
      if (month > 3) {
        year = year + 1;
      }
    }
    if (!date) {
      const d = new Date();
      year = d.getFullYear();
      const month = d.getMonth();
      if (month > 3) {
        year = year + 1;
      }
    }
    if (year && !isNaN(year) && client_id) {
      let url =
        "/api/openingbalance/payment/client/" +
        client_id +
        "/year/" +
        year +
        "?";
      if (p_id) {
        url = url + "&payment_id=" + p_id;
      }
      if (clientEntity_id) {
        url = url + "&clientEntity_id=" + clientEntity_id;
      }
      const openingbalance = await doGet(url);

      this.openingbalance = openingbalance;
    }
  }

  async recalculateTotal() {
    if (!this.isSet(this.collectible.amountReceived)) {
      this.collectible.amountReceived = 0;
    }
    let advnc = 0;
    if (this.prevCollect && this.prevCollect.advance && !this.isSet(advnc)) {
      advnc = this.prevCollect.advance;
    }
    if (!this.isSet(this.collectible.tds)) {
      this.collectible.tds = 0;
    }
    const aR = parseFloat(this.collectible.amountReceived);
    const advR = parseFloat(advnc);
    const tds = parseFloat(this.collectible.tds);
    this.collectible.totalAmount = this.roundOffToTwoDecimal(aR + tds);

    const tot = this.collectible.totalAmount + advR;
    if (this.singlePage) {
      if (this.collectible.tripList && this.collectible.tripList.length>0) {
        for (let i = 0; i < this.collectible.tripList.length; i++) {
          if (this.collectible.tripList[i].toBeCollected > 0) {
            if (tot > this.collectible.tripList[i].toBeCollected)
              this.collectible.tripList[i].collectAmount = Math.round(this.collectible.tripList[i].toBeCollected);
            else if (tot <= this.collectible.tripList[i].toBeCollected)
              this.collectible.tripList[i].collectAmount = Math.round(tot);
          }
        }
      }
    }

    this.setRemainingAmount();
  }

  settledTotal() {
    return (
      this.getTotalCollectAmount() +
      this.getTotalTDSAmount() +
      this.getTotalWriteOffAmount()
    );
  }

  settledTotalTrip() {
    return this.getTotalCollectAmountTrip();
  }

  getTotal() {
    let paymentAmount = this.roundOffToTwoDecimal(
      parseFloat(this.collectible.totalAmount)
    );
    if (this.prevCollect && this.prevCollect.advance) {
      paymentAmount =
        paymentAmount +
        this.roundOffToTwoDecimal(parseFloat(this.prevCollect.advance));
    }
    return paymentAmount;
  }

  async setRemainingAmount() {
    let totalReceived = this.getTotal();
    let totalSettled = this.settledTotal();
    let totalSettledTrip = this.settledTotalTrip();

    if (!this.isSet(totalReceived)) {
      totalReceived = 0;
    }
    if (!this.isSet(totalSettled)) {
      totalSettled = 0;
    }
    if (!this.isSet(totalSettledTrip)) {
      totalSettledTrip = 0;
    }
    if (
      this.collectible.invoiceList &&
      this.collectible.invoiceList.length > 0 &&
      this.collectible.tripList &&
      this.collectible.tripList.length > 0
    ) {
      this.collectible.advanceAmount = totalReceived - totalSettledTrip;
    } else if (
      this.collectible.tripList &&
      this.collectible.tripList.length > 0
    ) {
      this.collectible.advanceAmount = totalReceived - totalSettledTrip;
    } else if (
      this.collectible.invoiceList &&
      this.collectible.invoiceList.length > 0
    ) {
      this.collectible.advanceAmount = totalReceived - totalSettled;
    } else {
      this.collectible.advanceAmount =
        totalReceived - totalSettled - totalSettledTrip;
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
</style>
